import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CacheService } from '../cache.service';
import { NotifyService } from '../notify.service';
import { AppLoaderService } from '../system/app-loader/app-loader.service';
import { AppConfirmService } from '../system/app-confirm/app-confirm.service';
import {environment} from '@env/environment';

@Injectable()
export class SettingService {

  constructor(
    private http: HttpClient,
    private cache: CacheService,
    private toast: NotifyService,
    private loader: AppLoaderService,
    private confirm: AppConfirmService,
  ) {
  }

  refreshCache() {
    this.confirm.confirm({ message: 'Will clear the cache and exit the login, confirm please' }).subscribe((res) => {
      if (!res) return;
      let loader = this.loader.open();
      this.http.get(`settings/refresh-cache`)
        .finally(() => loader.close())
        .subscribe(() => {
          this.cache.removeAll();
          this.toast.show('Refresh cache success, will automatically refresh the page');
          setTimeout(() => {
            location.reload(true);
          }, 2000);
        });
    });
  }

  downUrl() {
    return environment.fileUrl;
  }

  baseUrl() {
    return environment.apiURL + environment.adminPrefix;
  }
}
